import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(private messageService: MessageService, private translate: TranslateService) { }

  showSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: this.translate.instant('toast.success'), detail: message });
  }

  showInfo(message: string) {
    this.messageService.add({ severity: 'info', summary: this.translate.instant('toast.info'), detail: message });
  }

  showWarn(message: string) {
    this.messageService.add({ severity: 'warn', summary: this.translate.instant('toast.warn'), detail: message });
  }

  showError(message: string) {
    this.messageService.add({ severity: 'error', summary: this.translate.instant('toast.error'), detail: message });
  }

  showContrast(message: string) {
    this.messageService.add({ severity: 'contrast', summary: this.translate.instant('toast.contrast'), detail: message });
  }

  showSecondary(message: string) {
    this.messageService.add({ severity: 'secondary', summary: this.translate.instant('toast.secondary'), detail: message });
  }

}

